module.exports = __webpack_public_path__ + "img/hybrid.ee5b14bb.png";